<h2 mat-dialog-title>Employment Details</h2>


  <mat-dialog-content>
<div class="dialog-content-container">
    <app-text-input label="Employer Name" [control]="roleForm.controls.employerName"></app-text-input>

    <app-select-input label="Employer Country" [control]="roleForm.controls.employerCountry" [lookupItems]="countries"
      placeholder="Select a Country">
    </app-select-input>

    <app-text-input label="Position Held" [control]="roleForm.controls.position"></app-text-input>

    <app-date-input label="Start Date" [control]="roleForm.controls.start"></app-date-input>
    <app-date-input label="End Date" [control]="roleForm.controls.end"></app-date-input>
    <app-text-area [control]="roleForm.controls.responsibilities" 
    label="Tasks / Responsibilities"></app-text-area>
</div>
  </mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="button" (click)="close()">OK</button>
  <button mat-flat-button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>